import { Controller } from '@hotwired/stimulus'

declare const $: (selector: string) => { modal: (action: string) => void }

export default class ModalTriggerController extends Controller<HTMLElement> {
  static values = {
    modal: String
  }

  declare readonly modalValue: string

  connect (): void {
    if (this.modalValue && window.location.hash === this.modalValue) {
      this.open()
    }
  }

  show (event: Event): void {
    event.preventDefault()
    this.open()
  }

  private open (): void {
    if (!this.modalValue) {
      return
    }

    $(this.modalValue).modal('show')
  }
}
